export function getFormValues(form, formFieldsRenderer, fieldRows) {

  const formValues = {};
  const fieldRowsLength = fieldRows.length;
  const fieldViews = formFieldsRenderer.el.views;

  for (let index = 0; index < fieldRowsLength; index++) {

    const fieldRow = fieldRows[index];
    const fieldView = fieldViews[index];

    const inputRenderer = fieldView.inputRenderer;

    formValues[fieldRow.label] = inputRenderer.getValue();

  }

  return formValues;

}